import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentSearchResult } from '../../../document/models/documentSearchResult';
import { CurriculumConstants } from '../../constants/curriculum.contants';
import { cloneDeep } from 'lodash-es';
import { MenuItem, MessageService, TreeNode } from 'primeng/api';
import { CurriculumService } from '../../services/curriculum.service';
import { CurriculumDetails } from '../../models/curriculumDetails';
import { EqmsScopeManagementService } from '../../../shared/services/eqms-scope-management.service';
import { TrainingItemDetails } from '../../models/trainingItemDetails';
import { Curriculum } from '../../models/curriculum';
import { CurriculumPersistenceService } from '../../services/curriculum-persistence.service';
import { catchError, throwError } from 'rxjs';
import { DocumentLibrarySearchComponent } from '../../../document-search/document-library-search/document-library-search.component';

@Component({
  selector: 'app-curriculum-document-details',
  templateUrl: './curriculum-document-details.component.html',
  styleUrls: ['./curriculum-document-details.component.scss']
})
export class CurriculumDocumentDetailsComponent implements OnInit{
  @Output() activateTabIndex = new EventEmitter<number>();
  feature:string = CurriculumConstants.Curriculum_Feature;
  documentSearchResult : DocumentSearchResult[] = [];
  isCurriculumSaveInProgress: boolean = false;
  curriculumSaveProgressMessage : string = CurriculumConstants.Curriculum_SaveInProgress;
  selectedDocuments: DocumentSearchResult[] = [];
  items: MenuItem[] = [];
  showAddButton : boolean = false;
  listOfSelectedDocuments:string[]=[];
  linkedTrainingItem : any;
  curriculumDetails !: CurriculumDetails;
  @Input() selectedScope!: TreeNode;
  @Input() eqmsScopeTreeNodes: TreeNode[] = [];
  scope?:number;
  trainingItemsList : TrainingItemDetails[]=[];
  curriculum !: Curriculum;
  trainingItemNumbers : string[] = [];
  isUpdate: boolean = false;
  addAndClose : boolean = false;
  errorCount : number = 0;
  eqmsScopes:number[] = [];
  displayDataCollected: string[] = [];
  trainingItemsDataToDisplay : string[] = [];
  curriculumDocumentDetails : string = CurriculumConstants.CurriculumDocumentDetails
  
  
  @ViewChild(DocumentLibrarySearchComponent)
  private docSearch!: DocumentLibrarySearchComponent;

  constructor(private messageService : MessageService,
    private curriculumService : CurriculumService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private curriculumPersistenceService : CurriculumPersistenceService){
    this.items = [
    {
        label: 'Add',
        command: this.add
    }
  ]
  }
  
  ngOnInit() : void{
    this.curriculumPersistenceService.curriculumSaveInProgress$.
      subscribe((curriculumSaveStatus) => {
        this.isCurriculumSaveInProgress = curriculumSaveStatus;
      });
    this.curriculumPersistenceService.closeAndResetCurriculumSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetCurriculumSlider(); }
    })
  }

  onSelectionOrDeselection = (documents: DocumentSearchResult[]) => {
    let selectedDocumentsList: string[] = [];
    documents.forEach(element => {
      selectedDocumentsList.push(element.documentNumber);
    });
    this.displayDataCollected=[]
    this.displayDataCollected = selectedDocumentsList;
    this.selectedDocuments = [];
    this.selectedDocuments = cloneDeep(documents);
  }

  addCurriculumAndClose(){
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose);
  }

  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetCurriculumSlider(){
    this.selectedDocuments = [];
    this.displayDataCollected = [];
    this.documentSearchResult = [];
    this.showAddButton = false;
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }


  getLinkedItems(addAndClose:boolean)
  {
    this.eqmsScopes = [];
    this.displayDataCollected = Object.assign([], this.displayDataCollected);
    this.errorCount=0; 
    this.scope = this.selectedScope.data.eQMSScopeId
    this.curriculumService.getCurriculum(this.scope).subscribe((curriculum)=>{
      this.curriculum = curriculum;
      this.curriculumPersistenceService.updateCurriculumDetails(curriculum);
      if(this.curriculum != null)
      {
        this.isUpdate = true;
      }
      this.validateAndCreateOrUpdateCurriculum(addAndClose);
      this.docSearch.getLinkedItemsSelection()
    });
  }

  validateAndCreateOrUpdateCurriculum(addAndClose:boolean){
    if(this.displayDataCollected.length<=0)
    {
      this.validateToSelectAtleastOneTrainingItem();
    }
    else
    {
        if(this.isUpdate){
          this.validateIfTrainingItemIsAlreadySaved(this.displayDataCollected);
        }
        else{
          this.validateIfTrainingItemIsAlreadySelected(this.displayDataCollected);
        }
          this.curriculumService.getLatestDocumentDetail(this.displayDataCollected)
        .pipe(
          catchError((err) => {
            this.messageService.add({
              severity: CurriculumConstants.Severity_Err,
              summary: `${err.error}`,
              life: 20000 
            });
            return throwError(() => err);
          })
        ).subscribe((serviceData) => {
           this.getParentScopesAndCompare(serviceData, this.isUpdate, this.addAndClose);           
        })
    }
  }

  validateToSelectAtleastOneTrainingItem(){
    this.errorCount=0;
    this.messageService.add({
      severity: CurriculumConstants.Severity_Err,
      summary: `${CurriculumConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      life: 20000
    });
    this.errorCount++;
  }

  validateIfTrainingItemIsAlreadySelected(matchingDocuments : any[]){
    var documentNumbers : string[] = [];
    matchingDocuments.find(element => {
      if(Object.values(this.trainingItemsDataToDisplay.indexOf(element)>=0))
      {
        documentNumbers.push(element);
      }
      else
      {
        this.trainingItemsDataToDisplay.push(element);
      }
      })
      this.displayDataCollected = documentNumbers.filter( x => !this.trainingItemsDataToDisplay.find(a=> a==x) );
      const sameElements = documentNumbers.filter( x => this.trainingItemNumbers.find(a=> a == x));
      if(sameElements.length > 0){
        this.validationMessageForTrainingItemAlreadyExisting(sameElements);
      }
  }

  validateIfTrainingItemIsAlreadySaved( matchingDocuments : any[]){
    var documentNumbers : string[] = [];
    this.trainingItemNumbers = [];
    this.curriculum.trainingItems.find(element=>{
      this.trainingItemNumbers.push(element.id);
    })
    matchingDocuments.find(element => {
      if(Object.values(this.trainingItemNumbers.indexOf(element)>=0))
      {
        documentNumbers.push(element);
       
      }
      else
      {
        this.listOfSelectedDocuments.push(element);
      }
      });
      this.displayDataCollected = documentNumbers.filter( x => !this.trainingItemNumbers.find(a=> a==x) );
      const sameElements = documentNumbers.filter( x => this.trainingItemNumbers.find(a=> a == x));
      if(sameElements.length > 0)
      {
        this.validationMessageForTrainingItemAlreadyExisting(sameElements);
      }
  }


    //since scopes are not matching, we are trying to get its parent scopes and compare with selected form scopes
    getParentScopesAndCompare(serviceData: any[], isUpdate: boolean, addAndClose: boolean) {
      const scopes: any[] =[];
      scopes.push(this.selectedScope.data.eQMSScopeId);
      this.selectedScope.data?.ancestors.forEach((ele : number) => {
        scopes.push(ele);
      });
      const matchingDocuments: any[] = [];
      const mismatchedDocuments: any[] = [];
      
      serviceData.forEach((data) => {
        const { eqmsScopes } = data;    
        const hasMatch = eqmsScopes.some((scope: number) => scopes.includes(scope));    
        if (hasMatch) {
          matchingDocuments.push(data);
        } else {
          mismatchedDocuments.push(data);
        }
      });
      if (mismatchedDocuments.length) {
        this.displayScopeValidationMessage(mismatchedDocuments);
      }
      if (matchingDocuments.length) {
        this.selectedItems(matchingDocuments);
        if(!isUpdate){
          this.addCurriculum(matchingDocuments,addAndClose);
        }
        else{
          this.updateCurriculum(matchingDocuments,addAndClose);
        }
      }
    }

    selectedItems(serviceData : any[]){
      if (!this.trainingItemsDataToDisplay || this.trainingItemsDataToDisplay.length === 0) {
        this.trainingItemsDataToDisplay = serviceData;
      } else {
        this.trainingItemsDataToDisplay.push(...serviceData);
      }
    }

    addCurriculum(matchingDocuments : any[],addAndClose : boolean){
        this.curriculumPersistenceService.prepareDataForDocumentTrainingItem(matchingDocuments,this.isUpdate, this.scope);
        this.curriculumPersistenceService.addCurriculum(addAndClose);
    }

    updateCurriculum(matchingDocuments : any[],addAndClose : boolean){
        this.curriculumPersistenceService.prepareDataForDocumentTrainingItem(matchingDocuments,
          this.isUpdate, this.scope);
        this.curriculumPersistenceService.updateCurriculum(addAndClose);
    }

    displayScopeValidationMessage(mismatchedDocuments: any[]) {
      this.errorCount = 0;
      const documentNumbersString = mismatchedDocuments.map((document) => `  ${document.number}`).join(', ');
      const validationMessage = CurriculumConstants.Selected_Documentscopes_Not_Matching_Error_Message.replace(
        'DocumentNumbers',
        `\n${documentNumbersString}`
      );
      this.messageService.add({
        severity: CurriculumConstants.Severity_Err,
        summary: `${validationMessage}`,
        life: 20000 
      });
      this.errorCount++;  
    }

    validationMessageForTrainingItemAlreadyExisting(matchingDocuments : any[]){
      this.errorCount = 0;
      const documentNumbersString = matchingDocuments.map((document) => `  ${document}`).join(', ');
        const validationMessage = CurriculumConstants.LinkedDocument_AlreadyExists_InCurriculum.replace(
          'DocumentNumbers',
          `\n${documentNumbersString}`
        );
        this.messageService.add({
          severity: CurriculumConstants.Severity_Err,
          summary: `${validationMessage}`,
          life: 20000 
        });
        this.errorCount++;
    }
}
